import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../services/file-uploader-service';
import { MysqlService } from './../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';
// import { WooActionsGridWidgetComponent } from '../woo-actions-grid-widget/woo-actions-grid-widget.component';


// import { WordpressService } from 'src/app/services/wordpress.service';
@Component({
  selector: 'app-system-action-lists',
  templateUrl: './system-action-lists.component.html',
  styleUrls: ['./system-action-lists.component.scss']
})

export class SystemActionListsComponent implements OnInit {

 // set this in the parent
//  doSomethingchild() {
//   this.refreshGrid();
// }
// set this in the parent
// add this to the drectives directives: [WooActionsGridWidgetComponent] // child component name
    // @ViewChild(WooActionsGridWidgetComponent) child:WooActionsGridWidgetComponent; // constructor
  /*
  ngAfterViewInit() {
      // child is set
      this.child.doSomethingChild();
    }
    */

    // @ViewChild(WooActionsGridWidgetComponent) child:WooActionsGridWidgetComponent;

  
    @Input() sent_data?: any; // not used
  
    // Grid Vars
    public data: DataManager;
    public data_subjects: DataManager;
    public pageSettings: Object;
    public pageOptions = { pageSize: 25 }; 
    public filterOptions: FilterSettingsModel;
    public formatOptions: Object;
    // public filterOptions: FilterSettingsModel;
    public filter : IFilter;
    public toolbarOptions: ToolbarItems[];
    @ViewChild('grid')
    public grid: GridComponent;
    public groupOptions: GroupSettingsModel;
    public templateOptionsDate: IFilterUI;
    public elem1: HTMLElement;
    public datePickerObj: DatePicker;
  
  
       // setup as observable?
       @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = 'side'; // side | abstract | full
  
  
    subjects_urgent: any;
    formatoptions: { type: string; format: string; };
    dateFormat: string;
    sortOptions: { columns: { field: string; direction: string; }[]; };
    today = new Date();
    initialPage: { pageSize: number; };
    open_jobs_count: any;
    myobCustomers: Object;
    arrCase: object[];
    Items: any;
    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    all_router_details: string;
    myob_tax_codes_live: Object;
    myob_tax_codes: Object;
    created_myob_tax_account: Object;
    updated_myob_tax_account: Object;
    sessionUserName: string;
    sessionUserLevel: number;
    sessionUserFullName: string;
    sessionUserFirstName: string;
    action_lists: any;
    action_lists_table: any;
    action_list: Object;
    action_list_removed: Object;
   
   
  
  
    constructor(
      private http: HttpClient, private _demoService: DemoService,
      private route: ActivatedRoute, public toastr: HotToastService,
       vcr: ViewContainerRef, private router: Router,
       public HttpClient:HttpClient,
       private fileUploader: FileUploaderService,
       private _mysqlService: MysqlService,
       private modalService: BsModalService,
       public datepipe: DatePipe,
       public gfunc: GlobalFunctionsService
    ) {   
  
      // Set and Access login Session Variables
      this.gfunc.setLoginSessionVars(); // set in a global function file
      this.sessionUserId = this.gfunc.currentUserVAR.user_id;
      this.sessionUsername = this.gfunc.currentUserVAR.username;
      this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
  
            // So set session vars manually. PPS Distro Hub - No Loging Required
            // this.sessionUserId = 142;
            // this.sessionUsername = 'temperosystems';
            // this.sessionUserName = 'temperosystems';
            // this.sessionBrandId = 125;
            // this.sessionUserLevel = 1000;
            // this.sessionUserFullName = 'tempero user';
            // this.sessionUserFirstName = 'tempero';    
      
          // need to add this as routes does not work globally
          this.all_router_details = this.router.url;
          this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
      
         }
      
         // check for changes. to load data.
         ngOnChanges(changes) {
          if (changes.item_id) {
            // deal with asynchronous Observable result
            this.item_id = changes.item_id.currentValue;
            // this.getJob(this.job_id);
          }
        }
  
        
    ngOnInit() {
  
        this.getActionLists();
                // Grid Options
                this.toolbarOptions = ['ExcelExport', 'Search'];
                this.initialPage = { pageSize:5 };
                this.filterOptions = {
                   type: 'Menu'
                };
               // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
                this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
                this.dateFormat = 'dd/MM/yyyy hh:mm a';
                this.filter = { params: { format: this.dateFormat } };
               // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
            
            
            // end date filter options
                // End Grid Options
        }
      
      
      
        // :: Grid Functions
      
      
      // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
      clickHandler(args: ClickEventArgs): void {
        if (args.item.id === 'Click') {
      
        //  this.grid.showSpinner();
      
        //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
       //  console.log(args.data.items);
       
      
      
        let pdfdata;
        const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
        for (let i = 0; i < query.queries.length; i++) {
          if (query.queries[i].fn === 'onPage') {
            query.queries.splice(i, 1);       // remove page query to get all records
            break;
          }
        }
        const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
          pdfdata = e.result as object[];  // get all filtered records
          const exportProperties = {
            dataSource: pdfdata,
          };
          // console.log(pdfdata.results);
      
         // this.search_results = pdfdata.records; // need this if a grouping is set.
        /*   this.search_results = pdfdata;
          this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
          this.toastr.success( "Press Start To Process Que");  */
         // this.grid.pdfExport(exportProperties);
        }).catch((e) => true);
        }
      
       //  this.grid.hideSpinner();
      
      };
      
      
      toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
            this.grid.excelExport();
        }
      }
      rowDataBound(args: RowDataBoundEventArgs) {
        const job_status = 'job_status';
        if (args.data[job_status] === 'CLOSED') {
            args.row.className = 'strikethrough';
        }
      }
      
        // :: Grid Functions
  
  
  
  
  
  
        public getMyobTaxCodesLive() {
          return  this._demoService.getMyobTaxCodesLive().subscribe(
              data => { this.myob_tax_codes_live = data;
                const res = data[0];
                 // https://www.concretepage.com/questions/577
                 this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                 // console.log(this.arrCase);
                 this.Items = data['Items'] ;
                 this.sent_data = this.Items;
        
                 // console.log(this.Items);
                // this.Address = this.Items['Address'];
          // return this.myobCustomers;
        
          // Map the data top the new model system
         // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
        
              },
              err => {
                // this.toastr.error('You need to login to MYOB again, Connection lost!');
               // console.error(err);
              },
              // () => console.log('done loading Trace Types')
            );
        
          }
    
  
          getMyobTaxCodes() {
            this._demoService.getMyobTaxCodes().subscribe(
               data => { this.myob_tax_codes = data;
                let res = data[0];
        
                // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                // // console.log(this.arrCase);
                // this.Items = data['Items'] ;
                // this.sent_data = this.Items;
                // this.sent_data = this.myob_account_codes;
        
              },
               err => console.error(err),
               // () => console.log('done loading Trace Types')
             );
           }
  
  
           refreshGrid(){ // refresh the databutton
            // this.loadList(this.doc_id);
            // this.getMyobTaxCodesLive();
            this.getActionLists();
            this.grid.refresh();
          };
  
  
  
  
          createMyobTaxCodesImport(model) {
  
            let TaxCollectedAccount;
            let TaxPaidAccount;
  
            if (typeof model.TaxCollectedAccount === 'undefined' || model.TaxCollectedAccount === null ) {
              TaxCollectedAccount = null;
            }else {
              TaxCollectedAccount = model.TaxCollectedAccount.UID; // can only call if actuall exist in the array!
            };
  
            if (typeof model.TaxPaidAccount === 'undefined' || model.TaxPaidAccount === null ) {
              TaxPaidAccount = null;
            }else {
              TaxPaidAccount = model.TaxPaidAccount.UID;
            };
        
            let new_model = null;
            // :: Build New model
            new_model = {
              myob_tax_code_name: model.Code,
              myob_tax_code_code: model.Code,
              myob_tax_id: model.UID,
              tax_percentage: model.Rate,
              UID: model.UID,
              Code: model.Code,
              Description: model.Description,
              Type: model.Type,
              Rate: model.Rate,
              IsRateNegative: model.IsRateNegative,
              TaxCollectedAccountUID: TaxCollectedAccount,
              TaxPaidAccountUID: TaxPaidAccount,
              LastModified: model.LastModified,
              RowVersion: model.RowVersion,
              myob_array: JSON.stringify(model)
            }; // multidimentional array push
        
        // run an external function to check the vaule - does not run before function not working
        // const check_val =  this.checkForLocalMyobAccountUID(model.UID);
        // console.log('Checked Value: ' + JSON.stringify(check_val));
        
        // lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
        // tslint:disable-next-line:max-line-length
        const localTaxAccountsLInkedArr = Object(this.myob_tax_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
        console.log('LocalCheckCount: ' + localTaxAccountsLInkedArr.length );
        const local_account_check_length = localTaxAccountsLInkedArr.length;
        
                    if (local_account_check_length === null || local_account_check_length === 0) {
                      console.log('We need to create this one.');
                          this._demoService.createMyobTaxCodes(new_model).subscribe(
                            data => {   this.created_myob_tax_account = data; // this is the retuned json upon creation.
                              //  let res = data[0];
                          this.toastr.success('Tax Code Created Locally');
                          // return true;
                            },
                            error => {
                              console.error(error);
                            });
        
                    } else {
                      console.log('We need to UPDATE this one');
                              const local_myob_tax_code_id = localTaxAccountsLInkedArr[0].myob_tax_code_id;
                              this._demoService.updateMyobTaxCodes(new_model, local_myob_tax_code_id).subscribe(
                                data => {   this.updated_myob_tax_account = data; // this is the retuned json upon creation.
                                  //  let res = data[0];
                              this.toastr.success('Tax Code Imported and Updated');
                              //  return true;
                                },
                                error => {
                                  console.error(error);
                                });
        
                    }
        this.getMyobTaxCodes(); // need to refresh the loop model for next press otherwise does not know of updates to myob_account_codes
           };
  
  
  
           getActionLists() {
            this._demoService.getActionLists().subscribe(
              data => {
                this.action_lists = data;
                this.action_lists_table = this.action_lists.slice(0, 10);
              },
              error => {
                 this.toastr.error( "Sorry, we were not able to get the lists");
                //  console.error('Error Loading User!');
                // return Observable.throw(error);
              }
            );
          }
  
  
          getActionList(action_list_id){
            this._demoService.getActionList(action_list_id).subscribe(
              res => {this.action_list = res;
              this.refreshGrid();
              },
              err => {
              this.toastr.error( "Sorry, we were not able to get the list");
                console.error(err.status);
                      }
            );
           }
          
  
           deleteActionList(action_list_id){
          if (confirm('Are you sure you wish to delete this action list? ID=' + action_list_id)) {
            this._demoService.deleteActionList(action_list_id).subscribe(
              res => {this.action_list_removed = res;
                this.toastr.success( "Done, action list removed.");
                this.refreshGrid();
              },
              err => {
              this.toastr.error( "Sorry, we were not able to delete the list");
                console.error(err.status);
                }
            );
                    }// end confirm
           }
  
  
  
  
  }
  